<template>
  <div class="game-card-wrapper">
    <div class="game-card-content">
      <div
        class="image-box"
        :class="[`image-box-bg-${(index % 6) + 1}`, typeClass]"
        @click="clickGame(item)"
        :data-src="item.gameImgUrl"
      >
        <Image fit="contain" :src="item.gameImgUrl" style="height: 100%" />
      </div>
      <div class="tools-bar">
        <span class="title">{{ item.play_cname || item.playCname }}</span>
        <div
          v-if="$route.name !== 'trial'"
          class="action-btn"
          :class="{ collection: item.play_collection === 2 }"
          @click.stop="handleCollection(item)"
        >
          <SvgIcon
            :iconName="item.play_collection === 2 ? 'star-solid' : 'star'"
            :width="45"
            :height="45"
            current-color
            v-if="!loading"
          />
          <van-loading v-else color="var(--theme-primary-color)" size="16" />
        </div>
      </div>
      <div class="repair-mask flex-center" v-if="item.state === 2 || item.play_state === 2">
        <!--        <svg-icon icon-name="repair" :width="153" current-color color="#fff" />-->
        <img class="icon-img" src="@/assets/img/home/repair.png" />
        <span class="text">维护中...</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import Image from '@/components/Image/index.vue';
import { handleFavorite, handleFavorite1, openGame } from '@/pages/home/index';
import { includes, toNumber } from 'lodash-es';
import { storeToRefs, useGameStore, useUserStore } from '@star/stores';
import { GameMainTypesEnum, gameMainTypesMap } from '@star/constants';
import { useRouter } from 'vue-router';
import { G_goLogin } from '@/plugins/public_utils';

type Props = {
  item: Record<string, any>;
  index: number;
};

const props = defineProps<Props>();

const gameStore = useGameStore();
const { activeHomeMainMenuTab, activeHomeSubMenuTab, gamesTryActive, gamesTry } = storeToRefs(gameStore);
const { isLogin } = storeToRefs(useUserStore());
const router = useRouter();

const loading = ref<boolean>(false);

const typeClass = computed(() => {
  return `${gameMainTypesMap[activeHomeMainMenuTab.value]}-${activeHomeSubMenuTab.value || gamesTry.value[gamesTryActive.value]?.play_id}`;
});

const clickGame = (item: any) => {
  openGame(item);
};

const handleCollection = async (item: any) => {
  console.log('收藏');
  if (!isLogin.value) {
    G_goLogin();
    return;
  }
  if (loading.value) return;
  loading.value = true;
  try {
    if (
      includes(
        [GameMainTypesEnum.ELECTRONIC, GameMainTypesEnum.FISHING, GameMainTypesEnum.CHESS],
        toNumber(activeHomeMainMenuTab.value)
      )
    ) {
      await handleFavorite(item);
    } else {
      await handleFavorite1(item);
    }
  } finally {
    setTimeout(() => {
      loading.value = false;
    }, 1000);
  }
};
</script>

<style lang="less" scoped>
.game-card-wrapper {
  width: 100%;
  height: 0;
  position: relative;
  padding-bottom: 87%;

  .game-card-content {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: var(--theme-backgroud-color);
    border-radius: 39px;
    overflow: hidden;
  }

  .image-box {
    width: 100%;
    height: calc(100% - 119px);
    background-color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;

    &.trial-60 {
      :deep(.van-image__img) {
        object-fit: cover !important;
      }
    }

    &.lottery-SGWIN {
      .image-wrapper {
        :deep(.van-image__img) {
          height: 62%;
        }
      }
    }

    &.lottery-tianCheng,
    &.lottery-GPI,
    &.lottery-DB {
      .image-wrapper {
        :deep(.van-image__img) {
          height: 84%;
        }
      }
    }

    &.image-box-bg-1 {
      background-image: radial-gradient(rgb(0 94 197 / 30%), rgb(0 94 197 / 100%));
    }

    &.image-box-bg-2 {
      background-image: radial-gradient(rgb(110 15 150 / 30%), rgb(110 15 150 / 100%));
    }

    &.image-box-bg-3 {
      background-image: radial-gradient(rgb(141 0 103 / 30%), rgb(141 0 103 / 100%));
    }

    &.image-box-bg-4 {
      background-image: radial-gradient(rgb(154 0 0 / 30%), rgb(154 0 0 / 100%));
    }

    &.image-box-bg-5 {
      background-image: radial-gradient(rgb(45 8 130 / 30%), rgb(45 8 130 / 100%));
    }

    &.image-box-bg-6 {
      background-image: radial-gradient(rgb(149 85 37 / 30%), rgb(149 85 37 / 100%));
    }
  }

  .tools-bar {
    width: 100%;
    height: 120px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 30px;
    position: absolute;
    bottom: 0;
    z-index: 1;
    background-color: #fff;

    .title {
      font-size: 45px;
      font-weight: 400;
      color: #2e2e2e;
      flex: 1;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      max-width: 80%;
    }

    .action-btn {
      &.collection {
        .svg-icon {
          color: var(--theme-btn-primary-color);
        }
      }
    }
  }
}

.game-list-wrapper {
  &.fishing,
  &.electronic,
  &.chess {
    .image-wrapper :deep(.van-image__img) {
      height: 75% !important;
    }
  }
}
</style>
